import { combineReducers } from 'redux';
import Global from './global/reducers';
import patientReducer from './PatientReducer/patientReducer';

const rootReducer = combineReducers({
  global: Global,
  patient: patientReducer,
});

export default rootReducer;